import { useTranslation } from "react-i18next";
import {
  FaTelegram,
  FaWhatsapp
} from "react-icons/fa";
import "../i18n";

const Header = () => {
  const { t } = useTranslation();

  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng); // Change language
  // };
  return (
    <>
      <section id="header">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-12" data-aos="fade-up">
              <span>{t("welcomeSubtitle")}</span>
              <h1 className="display-1">{t("welcome")}</h1>
              <p className="lead description">
                {t("welcomeDescription")}
              </p>
              <div className="d-flex justify-content-center flex-wrap">
                {/* <a href="https://wa.me/37129825460" className="btn btn-lg me-3">
                  {t("BookNow")}
                </a> */}
                <a href="https://wa.me/37129825460" className="btn btn-lg me-0 me-md-3" style={{backgroundColor: "#25D366", color: "white"}}>
                  <FaWhatsapp className="me-1" /> {t("WhatsApp")}
                </a>
                <a href="https://t.me/+37129825460" className="btn btn-lg mt-2 mt-md-0" style={{backgroundColor: "#0088cc", color: "white"}}>
                  <FaTelegram className="me-1" /> {t("Telegram")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Header;
